import React, { useContext, createContext, useReducer } from "react";

const initialState = {
  category: [],
};

const storeReduceer = (state, action) => {
  const { type, payload } = action;
  switch (type) {
    case "FETCH_CAT":
      return { ...state, category: payload };
    default:
      return state;
  }
};

const StoreContext = createContext();

export const StoreProvider = ({ children }) => {
  const [state, dispatch] = useReducer(storeReduceer, initialState);

  return <StoreContext.Provider value={{ state, dispatch }}>{children}</StoreContext.Provider>;
};

export const useStore = (x="") => {
  const {state,dispatch} = useContext(StoreContext);
  if(x !== "") return {state:state[x],dispatch};
  return {state,dispatch};
};
